module.exports = __webpack_public_path__ + "static/media/post-bonus.4e8cf2b1.png";